var _g, _path, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMaticOutline = function SvgMaticOutline(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1102_6959)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "white",
    fillOpacity: 0.33
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3349 12.6707C18.0854 12.5281 17.7647 12.5281 17.4796 12.6707L15.4839 13.8467L14.1296 14.5951L12.1696 15.7711C11.9201 15.9137 11.5994 15.9137 11.3143 15.7711L9.78187 14.8445C9.53241 14.702 9.35422 14.4169 9.35422 14.0962V12.3143C9.35422 12.0292 9.49677 11.7441 9.78187 11.5659L11.3143 10.675C11.5637 10.5324 11.8845 10.5324 12.1696 10.675L13.702 11.6015C13.9515 11.7441 14.1296 12.0292 14.1296 12.3499V13.526L15.4839 12.7419V11.5303C15.4839 11.2452 15.3413 10.9601 15.0562 10.7819L12.2052 9.10691C11.9558 8.96436 11.635 8.96436 11.3499 9.10691L8.42765 10.8175C8.14255 10.9601 8 11.2452 8 11.5303V14.8802C8 15.1653 8.14255 15.4504 8.42765 15.6286L11.3143 17.3035C11.5637 17.4461 11.8845 17.4461 12.1696 17.3035L14.1296 16.1631L15.4839 15.3791L17.4439 14.2387C17.6934 14.0962 18.0141 14.0962 18.2992 14.2387L19.8316 15.1296C20.0811 15.2722 20.2593 15.5573 20.2593 15.878V17.6599C20.2593 17.945 20.1167 18.2301 19.8316 18.4083L18.3349 19.2992C18.0854 19.4418 17.7647 19.4418 17.4796 19.2992L15.9472 18.4083C15.6977 18.2657 15.5195 17.9806 15.5195 17.6599V16.5195L14.1653 17.3035V18.4796C14.1653 18.7647 14.3078 19.0498 14.5929 19.228L17.4796 20.9029C17.729 21.0455 18.0498 21.0455 18.3349 20.9029L21.2215 19.228C21.471 19.0854 21.6492 18.8003 21.6492 18.4796V15.094C21.6492 14.8089 21.5066 14.5238 21.2215 14.3456L18.3349 12.6707Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1102_6959",
    x: -5,
    y: -5,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1102_6959"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1102_6959",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaticOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/matic-outline.d68dea22.svg";
export { ForwardRef as ReactComponent };